<script setup>
import ActionButton from '@/components/shared/buttons/ActionButton.vue'

//Emits and props
defineEmits([
  'click',
])
</script>

<template>
  <ActionButton
    v-bind="$attrs"
    type="text"
    icon="close"
    aria-label="Close"
    test-id="closeButton"
    @click="$emit('click', $event)"
  />
</template>
